



















import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { IRole, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'role',
  }),
  mixins: [paginationMixin],
})
export default class RoleList extends Vue {
  @Action('getEntities', { namespace: 'role' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'role' })
  entitiesSlice: IRole[];
  @State('pageParams', { namespace: 'role' }) pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
  interval = null;
  created() {
    this.getEntities();
  }
}
